import { useMutation } from 'react-query';
import { controlBackdropLoading, removeCache, repairService } from '../../../services';
import {
  RepairUpdateProps,
  RepairUpdateImagesProps,
  RepairConfirmProps,
  IdProps,
} from '../../../types';

export const useSetPriceRepairMutation = () => {
  return useMutation(
    (props: RepairUpdateProps[]) => {
      return repairService.setPrice(props);
    },
    {
      onSettled: () => {
        removeCache(['repair', 'container', 'key']);
      },
    },
  );
};

export const useUpdateRepairMutation = () => {
  return useMutation(
    (props: RepairUpdateProps) => {
      return repairService.update(props);
    },
    {
      onSettled: () => {
        removeCache(['repair', 'key']);
      },
    },
  );
};

export const useRepairConfirmMutation = () => {
  return useMutation(
    (props: RepairConfirmProps) => {
      return repairService.confirm(props);
    },
    {
      onSettled: () => {
        removeCache(['repair', 'key']);
      },
    },
  );
};

export const useCompleteRepairMutation = () => {
  return useMutation(
    (props: IdProps) => {
      return repairService.complete(props);
    },
    {
      onSettled: () => {
        removeCache(['repair', 'key']);
      },
    },
  );
};

export const useRepairCreateInvoiceMutation = () => {
  return useMutation(
    (props: IdProps[]) => {
      return repairService.createInvoice(props);
    },
    {
      onSettled: () => {
        removeCache(['repair', 'invoice', 'key']);
      },
    },
  );
};

export const useRepairDeleteMutation = () => {
  return useMutation(
    (props: IdProps) => {
      return repairService.delete(props);
    },
    {
      onSettled: () => {
        removeCache(['repair', 'key']);
      },
    },
  );
};

export const useUpdateImagesRepairMutation = () => {
  return useMutation(
    ({ id, photos = [], action }: RepairUpdateImagesProps) => {
      controlBackdropLoading(1);

      return repairService.updateImages({ id, photos, action });
    },
    {
      onSettled: () => {
        removeCache(['repair', 'key']);
        controlBackdropLoading(-1);
      },
    },
  );
};
